<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">{{ this.currentView }}</h2>
          <div class="section__buttons">
            <router-link to="/banners/add_banner" class="btn add">
              <i class="fas fa-plus ms-1"></i>
              إضافة اعلان جديد
            </router-link>

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.banners.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th scope="col">عنوان</th>
                  <th style="width: 10%" scope="col">النوع</th>
                  <th style="width: 40%" scope="col">الوصف</th>
                  <th style="width: 30%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(banner, index) in this.banners" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>
                    <div v-if="banner.banner_type == 1">
                      {{ banner.title }}
                    </div>
                    <div v-if="banner.banner_type == 2">
                      <img
                        style="width: 200px"
                        :src="banner.image_url"
                        alt="banner_img"
                      />
                    </div>
                    <div v-if="banner.banner_type == 3">
                      <img
                        v-if="banner.image_url"
                        style="width: 200px"
                        :src="banner.image_url"
                        alt="banner_img"
                      />
                      <div class="mt-2">
                        {{ banner.title }}
                      </div>
                    </div>
                  </td>
                  <td>{{ filterItems(banner.banner_type) }}</td>
                  <td>
                    <div v-if="banner.banner_type != 2">
                      {{ banner.description }}
                    </div>
                    <div v-else>لا يوجد وصف</div>
                  </td>
                  <td>
                    <router-link
                      class="btn view"
                      :to="{
                        name: 'view_banner',
                        params: { id: banner.banner_id },
                      }"
                    >
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </router-link>
                    <router-link
                      class="btn edit me-2"
                      :to="{
                        name: 'edit_banner',
                        params: { id: banner.banner_id },
                      }"
                    >
                      <i class="fas fa-edit"></i>
                      تعديل
                    </router-link>

                    <button
                      class="btn me-2 delete"
                      @click="this.deleteSelectedBanner(banner)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.banners) || this.banners.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد اعلانات حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      currentView: "الاعلانات",
      banners: [],
      // Loading
      isloading: false,
      firstLoad: "",
      // Search
      searchValue: "",
    };
  },
  methods: {
    ...mapActions("bannersModule", ["fetchBanners", "deleteBanner"]),
    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.banners.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.banners.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------
    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.banners = this.getBanners.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------
    deleteSelectedBanner(banner) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الاعلان؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف المعلومة بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteBanner(banner.banner_id);
          if (banner.banner_type != 1) {
            deleteFileFromUrl(banner.image_url);
          }
        }
      });
    },
    //--------------------------------------------
    filterItems(type) {
      switch (type) {
        case 1:
          return "نص";
        case 2:
          return "صورة";
        case 3:
          return "نص وصورة";
      }
    },
  },
  async created() {
    if (this.isFirstLoad) await this.fetchBanners();
  },
  computed: {
    ...mapGetters("bannersModule", ["getBanners", "isLoading", "isFirstLoad"]),
  },
  mounted() {
    this.banners = this.getBanners;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
  },
  watch: {
    getBanners() {
      this.banners = this.getBanners;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
  },
};
</script>

<style>
</style>